import { Ics2CustomsRequest, Ics2Referral } from 'store/declarations/eu/ics2/customs-requests/types';
import { Ics2UploadedFile, isIcs2DocumentSendable, isSelectableIcs2Document } from 'store/file-upload/ics2';

export type Ics2ReferralRow = {
    request: Ics2CustomsRequest;
    referral: Ics2Referral;
};

export type Ics2DocumentsByReferral = Record<string, Ics2UploadedFile[]>;

const documentKey = (notificationId?: string, referralRequestReference?: string) =>
    `${notificationId}::${referralRequestReference}`;

const rowKey = ({ request, referral }: Ics2ReferralRow) =>
    documentKey(request.notificationId, referral.referralRequestReference);

export const indexSelectableByReferral = (files: Ics2UploadedFile[]): Ics2DocumentsByReferral =>
    files.filter(isSelectableIcs2Document).reduce<Ics2DocumentsByReferral>((index, file) => {
        const key = documentKey(file.fileInfo?.requestNotificationId, file.fileInfo?.referralRequestReference);
        index[key] = [...(index[key] ?? []), file];
        return index;
    }, {});

export const getReferralAttachments = (documents: Ics2DocumentsByReferral, row: Ics2ReferralRow) =>
    documents[rowKey(row)] ?? [];

export const toAttachmentContext = (files: Ics2UploadedFile[]) => ({
    attachmentCount: files.length,
    unverifiedAttachmentCount: files.filter((file) => !isIcs2DocumentSendable(file)).length,
});

export const getDocumentVersions = (documents: Ics2DocumentsByReferral, rows: Ics2ReferralRow[]) =>
    rows
        .flatMap((row) => getReferralAttachments(documents, row))
        .reduce<Record<string, number>>((versions, file) => {
            versions[file.id] = file.metadataVersion;
            return versions;
        }, {});
